$fontSize: 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24;
$buttonSize: 24, 32;

:host {
  display: inline-block;
  width: auto;
  --cursor-type: pointer;

  button {
    line-height: calc(var(--spacer) * 3);
    background: var(--blue-layout-400-primary);
    font-size: 15px;
    padding: 0;
    overflow: hidden;
    cursor: var(--cursor-type, pointer);
    border: none;
    border-color: inherit;
    transition: background-color 0.3s ease 0s, color 0.3s ease 0s;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: var(--blue-layout-500-focus) solid 2px !important;
    }

    &.btn-color {
      &--primary {
        color: var(--blue-layout-400-primary);
        border-color: var(--blue-layout-400-primary);
        gz-icon::part(svgIcon) {
          fill: var(--blue-layout-400-primary);
        }
        &:hover {
          background-color: var(--blue-layout-050-selected);
          color: var(--blue-layout-301-active);
          fill: var(--blue-layout-301-active);

          gz-icon::part(svgIcon) {
            fill: var(--blue-layout-301-active);
          }
        }
      }
      &--primary-active {
        color: var(--blue-layout-301-active);
      }
      &--secondary {
        color: var(--chart-300-icon-buttons);
        border-color: var(--chart-300-icon-buttons);
        gz-icon::part(svgIcon) {
          fill: var(--chart-302-icon-buttons-titles);
        }
        &.btn-type--square {
          color: var(--chart-302-icon-buttons-titles);
          gz-icon::part(svgIcon) {
            fill: var(--chart-302-icon-buttons-titles);
          }
        }
        &.btn-type--round {
          color: var(--body-text-arrows-400);
        }
        &:hover:not(.btn-type--square) {
          color: var(--chart-300-icon-buttons);
          gz-icon::part(svgIcon) {
            fill: var(--chart-300-icon-buttons);
          }
        }
      }
      &--success {
        color: var(--green-layout-100-primary-green);
        border-color: var(--green-layout-100-primary-green);
        gz-icon::part(svgIcon) {
          fill: var(--green-layout-100-primary-green);
        }
        &:hover {
          color: var(--green-layout-050-secondary-green);
          gz-icon::part(svgIcon) {
            fill: var(--green-layout-050-secondary-green);
          }
        }
      }
      &--negative {
        color: var(--red-layout-300-primary);
        border-color: var(--red-layout-300-primary);
        gz-icon::part(svgIcon) {
          fill: var(--red-layout-300-primary);
        }
        &:hover {
          background-color: var(--red-layout-050-background);
        }
      }
      &--white {
        color: var(--white-layout-300-primary);
        gz-icon::part(svgIcon) {
          fill: var(--white-layout-300-primary);
        }
      }
    }
    &.btn-fill {
      &--primary {
        color: var(--white-layout-300-primary);
        background-color: var(--blue-layout-403-primary);
        border: none;
        gz-icon::part(svgIcon) {
          fill: var(--white-layout-300-primary);
        }
        &:hover {
          background-color: var(--blue-layout-301-active);
        }
        &:active {
          background-color: var(--blue-layout-501-focus);
        }
      }
      &--secondary {
        color: var(--white-layout-300-primary);
        background-color: var(--body-text-arrows-400);
        border: none;
        gz-icon::part(svgIcon) {
          fill: var(--white-layout-300-primary);
        }
        &:hover {
          background-color: var(--chart-300-icon-buttons);
        }
        &:active {
          background-color: var(--chart-300-icon-buttons);
        }
      }
      &--success {
        color: var(--white-layout-300-primary);
        background-color: var(--green-layout-100-primary-green);
        gz-icon::part(svgIcon) {
          fill: var(--white-layout-300-primary);
        }
        &:hover {
          background-color: var(--green-layout-050-secondary-green);
        }
      }
      &--negative {
        color: var(--white-layout-300-primary);
        background-color: var(--red-layout-300-primary);
        border: none;
        gz-icon::part(svgIcon) {
          fill: var(--white-layout-300-primary);
        }
        &:hover {
          background-color: var(--red-layout-300-primary);
        }
      }
      &--white {
        background-color: transparent;
      }
      &--outline {
        border: 1px solid transparent;
        background-color: transparent;
        &.btn-color {
          &--primary {
            border-color: var(--blue-layout-400-primary);
            &:hover {
              border-color: var(--blue-layout-301-active);
            }
          }
          &--secondary {
            border-color: var(--body-text-arrows-400);
          }
          &--negative {
            border-color: var(--red-layout-300-primary);
            &:hover {
              border-color: var(--red-layout-300-primary);
            }
          }
          &--success {
            border-color: var(--green-layout-100-primary-green);
            &:hover {
              border-color: var(--green-layout-100-primary-green);
            }
          }
        }
      }
      &--quiet {
        background-color: transparent;
        border-color: transparent;
        &:active {
          &.btn-color {
            &--secondary {
              color: var(--main-titles-inputs-600);
              gz-icon::part(svgIcon) {
                fill: var(--main-titles-inputs-600);
              }
            }
          }
        }
      }
    }
    &.btn-type {
      &--round,
      &--square {
        border-radius: 4px;
        &:hover {
          &.btn-color {
            &--secondary {
              background-color: var(--chart-050-hover);
            }
            &--primary {
              color: var(--blue-layout-400-primary);
              gz-icon::part(svgIcon) {
                fill: var(--blue-layout-400-primary);
              }
            }
          }
        }
        &:active {
          &.btn-color {
            &--secondary {
              background-color: transparent;
            }
          }
        }
        &:focus-visible {
          &.btn-fill {
            &--primary {
              background-color: var(--blue-layout-500-focus);
            }
          }
        }

        &:not(.btn-fill--quiet) {
          &:focus-visible {
            outline: none;
          }
        }
      }
      &--no_hover {
        background-color: transparent;
      }
    }

    span {
      line-height: 1;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }
}

:host(.active) {
  .icon-btn {
    color: var(--blue-layout-301-active) !important;
  }
  gz-icon::part(svgIcon) {
    fill: var(--blue-layout-301-active) !important;
  }
}

:host(:active) {
  button.btn-color--secondary.btn-fill--quiet {
    color: var(--blue-layout-301-active) !important;
  }
}

@each $size in $fontSize {
  :host([fontSize='#{$size}']) {
    button {
      font-size: #{$size}px;
    }
  }
}

@each $size in $buttonSize {
  :host([size='#{$size}']) {
    button {
      width: #{$size}px;
      height: #{$size}px;
    }
  }
}

:host([disabled]) {
  opacity: 0.3;
  pointer-events: none;
  transition: none;
  button {
    cursor: default;
  }
}

:host([disabled][showSpinner]) {
  button {
    opacity: 1;
  }
}

:host(.split-button) {
  button {
    border-radius: 0 calc(2 * var(--spacer)) calc(2 * var(--spacer)) 0;
    width: auto;
    height: 32px;
    padding: 0 10px 0 5px;
    &.btn-color {
      &--primary {
        &.btn-fill {
          &--full {
            &.btn-color--primary {
              color: var(--white-layout-300-primary);
              background-color: var(--blue-layout-403-primary);
              gz-icon::part(svgIcon) {
                fill: var(--white-layout-300-primary);
              }
              &:hover {
                background-color: var(--blue-layout-301-active);
                fill: var(--blue-layout-301-active);
              }
              &:active {
                background-color: var(--blue-layout-500-focus);
                fill: var(--blue-layout-500-focus);
              }
            }
          }
          &--outline {
            border-color: var(--blue-layout-400-primary);
            color: var(--blue-layout-300-active);
            fill: var(--blue-layout-403-primary);
            border-left: none;
          }
        }
      }
    }
  }
}
